// extracted by mini-css-extract-plugin
export default {"container":"salesPoints_container__Ats7+","loader":"salesPoints_loader__LWkXB","rotate":"salesPoints_rotate__KkE1A"};